import { useTranslation } from 'react-i18next'
import { AddCarLicensee } from '~/features/common/Organization/CarLicensees/AddCarLicensee'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'organizations', link: '/organizations/car-licensees' },
  { titleI18n: 'licensees', link: '/organizations/car-licensees' },
  { titleI18n: 'new licensee' },
]

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'requisites', anchor: 'requisites' },
  { labelI18n: 'registry', anchor: 'registry' },
  { labelI18n: 'employees', anchor: 'employees' },
  { labelI18n: 'contacts', anchor: 'contacts' },
]

export function AddCarLicenseePage() {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('new licensee')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('new licensee')}</PageTitle>
      </Container>
      <AddCarLicensee />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
